module.exports = __webpack_public_path__ + "static/media/sala_principal_7.a64aa355.jpg";